// extracted by mini-css-extract-plugin
export default {"container":"MobileInputComponent_container__ZWRM3","extras":"MobileInputComponent_extras__DQRRP"};